import { configureStore } from "@reduxjs/toolkit";
import userInfoReducer from './userInfoSlice';
import notificationReducer from './notificationSlice';

export default configureStore({
    reducer: {
        userInfo: userInfoReducer,
        notification: notificationReducer,
    }
})